var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "changePassword" } },
    [
      _c(
        "v-container",
        { staticClass: "fill-height", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "change-password_slim",
                  attrs: { cols: "12", sm: "4", md: "4" }
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "change_password_card",
                      attrs: { elevation: "10" }
                    },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "change-password" },
                        [
                          !!_vm.messageOk
                            ? _c("v-alert", { attrs: { type: "success" } }, [
                                _vm._v(" " + _vm._s(_vm.messageOk))
                              ])
                            : _vm._e(),
                          !!_vm.message
                            ? _c("v-alert", { attrs: { type: "error" } }, [
                                _vm._v(" " + _vm._s(_vm.message))
                              ])
                            : _vm._e(),
                          _c(
                            "v-form",
                            {
                              ref: "cpform",
                              attrs: {
                                id: "change-password-form",
                                autocomplete: "off"
                              },
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  _vm.submitchange - _vm.password
                                }
                              }
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: { align: "center", justify: "center" }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "8", md: "8" } },
                                    [
                                      _c(
                                        "h1",
                                        {
                                          staticClass:
                                            "change-password_prihlasenie"
                                        },
                                        [_vm._v("Zmeniť Signatus heslo")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  attrs: {
                                    align: "center",
                                    justify: "center",
                                    "no-gutters": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "8", md: "8" } },
                                    [
                                      _c(
                                        "form-component",
                                        { attrs: { title: "" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "dynamic-input-control",
                                            attrs: {
                                              "append-icon": _vm.showPass_new1
                                                ? "mdi-eye"
                                                : "mdi-eye-off",
                                              rules: [
                                                _vm.rules.password_new1,
                                                _vm.rules
                                                  .password_format_number,
                                                _vm.rules.password_format_length
                                              ],
                                              type: _vm.showPass_new1
                                                ? "text"
                                                : "password",
                                              label: "Nové heslo",
                                              outlined: ""
                                            },
                                            on: {
                                              "click:append": function($event) {
                                                _vm.showPass_new1 = !_vm.showPass_new1
                                              }
                                            },
                                            model: {
                                              value: _vm.password_new1,
                                              callback: function($$v) {
                                                _vm.password_new1 = $$v
                                              },
                                              expression: "password_new1"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  attrs: {
                                    align: "center",
                                    justify: "center",
                                    "no-gutters": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "8", md: "8" } },
                                    [
                                      _c(
                                        "form-component",
                                        { attrs: { title: "" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "dynamic-input-control",
                                            attrs: {
                                              "append-icon": _vm.showPass_new2
                                                ? "mdi-eye"
                                                : "mdi-eye-off",
                                              rules: [
                                                _vm.rules.password_new2,
                                                _vm.rules.password_new2_equality
                                              ],
                                              type: _vm.showPass_new2
                                                ? "text"
                                                : "password",
                                              label: "Zopakujte heslo",
                                              outlined: ""
                                            },
                                            on: {
                                              "click:append": function($event) {
                                                _vm.showPass_new1 = !_vm.showPass_new1
                                              }
                                            },
                                            model: {
                                              value: _vm.password_new2,
                                              callback: function($$v) {
                                                _vm.password_new2 = $$v
                                              },
                                              expression: "password_new2"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { align: "center", justify: "center" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "8", md: "8" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        depressed: ""
                                      },
                                      on: { click: _vm.changePassword }
                                    },
                                    [_vm._v("Zmeniť heslo")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "change-password-cancel",
                                      attrs: {
                                        to: "/",
                                        color: "secondary",
                                        ripple: false,
                                        plain: ""
                                      },
                                      on: { click: _vm.changePasswordCancel }
                                    },
                                    [_vm._v("Zrušiť")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }